<template>
  <div :class="[`${styleType}Text`]">
    <b-alert id="explanatoryText" show>{{ $t(value) }}</b-alert>
  </div>
</template>

<script>
export default {
  name: 'ExplanatoryText',
  props: {
    value: {
      default: '',
      type: String
    },

    styleType: {
      type: String,
      default: 'normal'
    }
  }
}
</script>

<style lang="scss" scoped>
$text-color: white;
$background-color: #c1aecf;
$border-color: #8b69a9;

#explanatoryText {
  color: $text-color;
  background: $background-color !important;
  border-radius: 10px;
  border: 2px $border-color solid;
}

/*style types*/
.compressedText {
  display: grid;
  grid-template-columns: 60%;
  margin-left: 5%;
}
</style>
